
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class ReceiptMaterialItemsGrid extends Serenity.EntityGrid<ReceiptMaterialItemsRow, any> {
        protected getColumnsKey() { return 'Production.ReceiptMaterialItems'; }
        protected getDialogType() { return ReceiptMaterialItemsDialog; }
        protected getIdProperty() { return ReceiptMaterialItemsRow.idProperty; }
        protected getInsertPermission() { return ReceiptMaterialItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return ReceiptMaterialItemsRow.localTextPrefix; }
        protected getService() { return ReceiptMaterialItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}